import { ItemModifier } from '@wix/ambassador-ecom-v1-order/types';
import { useTranslation } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import Text, { TextType } from '../../../../../../../../Components/Text';
import { BookingBodyContentAddOnsListDataHooks } from '../../../../../../../datahooks';

export interface BookingBodyContentAddOnsListProps {
  addOns: ItemModifier[];
  dataHook: string;
}

const BookingBodyContentAddOnsList: FC<BookingBodyContentAddOnsListProps> = ({
  addOns,
  dataHook,
}) => {
  const { t } = useTranslation();
  return (
    <ul data-hook={dataHook}>
      {addOns.map((addOn) => (
        <li key={addOn.id}>
          <Text
            type={TextType.Secondary}
            data-hook={BookingBodyContentAddOnsListDataHooks.Text + addOn.id}
          >
            {t('app.my-bookings-widget.booking-content.add-on-details', {
              addOnQuantity: addOn.quantity ?? 1,
              addOnLabel: addOn.label?.translated,
            })}
          </Text>
        </li>
      ))}
    </ul>
  );
};

export default BookingBodyContentAddOnsList;
